export default __webpack_public_path__ + "static/media/close_Icon.a6887339.svg";